var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import ReactDOM from "react-dom";
import React, { Component } from "react";
import { FacebookShareButton, TwitterShareButton, EmailShareButton, WhatsappShareButton, PinterestShareButton } from "react-share";
import { FacebookIcon, TwitterIcon, MailIcon, WhatsappIcon, PinterestLightIcon } from "@riseart/icons";
import { Heading, Paragraph } from "@riseart/common";
import { Overlay, OverlayBody, OverlayContainer, OverlayHeader } from "@riseart/layout";
import { shareCls, shareListCls, shareListItemCls, shareListItemButtonCls, shareListItemButtonInnerCls, shareOverlayCls } from "./Overlay.less";
var SHARE_KEYS = {
  facebook: "facebook",
  twitter: "twitter",
  email: "email",
  whatsapp: "whatsapp",
  pinterest: "pinterest"
};
var ShareOverlay = /* @__PURE__ */ function(_Component) {
  function ShareOverlay2(props) {
    var _this;
    _classCallCheck(this, ShareOverlay2);
    _this = _callSuper(this, ShareOverlay2, [props]);
    _this.bindMethods();
    _this.el = document.createElement("div");
    return _this;
  }
  __name(ShareOverlay2, "ShareOverlay");
  _inherits(ShareOverlay2, _Component);
  return _createClass(ShareOverlay2, [{
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function componentDidMount() {
      document.body && document.body.appendChild(this.el);
    }, "componentDidMount")
    /**
     * componentWillUnmount
     */
  }, {
    key: "componentWillUnmount",
    value: /* @__PURE__ */ __name(function componentWillUnmount() {
      document.body && document.body.removeChild(this.el);
    }, "componentWillUnmount")
    /**
     * handleShareClick
     */
  }, {
    key: "handleShareClick",
    value: /* @__PURE__ */ __name(function handleShareClick(key) {
      var onShare = this.props.onShare;
      return function() {
        if (typeof onShare === "function") {
          onShare(key);
        }
      };
    }, "handleShareClick")
    /**
     * bindMethods
     */
  }, {
    key: "bindMethods",
    value: /* @__PURE__ */ __name(function bindMethods() {
      this.handleShareClick = this.handleShareClick.bind(this);
    }, "bindMethods")
    /**
     * render
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var _this$props = this.props, isVisible = _this$props.isVisible, url = _this$props.url, _this$props$urlsByPla = _this$props.urlsByPlatform, urlsByPlatform = _this$props$urlsByPla === void 0 ? {} : _this$props$urlsByPla, image = _this$props.image, description = _this$props.description, translations = _this$props.translations, onClose = _this$props.onClose;
      return /* @__PURE__ */ ReactDOM.createPortal(/* @__PURE__ */ React.createElement(Overlay, {
        isVisible,
        onClose,
        type: "semitransparent",
        size: "small",
        className: shareOverlayCls
      }, /* @__PURE__ */ React.createElement(OverlayContainer, null, /* @__PURE__ */ React.createElement(OverlayHeader, {
        border: false
      }, /* @__PURE__ */ React.createElement(Heading, {
        tag: "h3",
        level: "3"
      }, translations.title)), /* @__PURE__ */ React.createElement(OverlayBody, {
        className: shareCls
      }, description && /* @__PURE__ */ React.createElement(Paragraph, null, description), /* @__PURE__ */ React.createElement("ul", {
        className: shareListCls
      }, /* @__PURE__ */ React.createElement("li", {
        className: shareListItemCls,
        onClick: this.handleShareClick(SHARE_KEYS.facebook)
      }, /* @__PURE__ */ React.createElement(FacebookShareButton, {
        resetButtonStyle: false,
        url: urlsByPlatform.facebook || url,
        quote: translations.messages.facebook,
        className: shareListItemButtonCls
      }, /* @__PURE__ */ React.createElement("div", {
        className: shareListItemButtonInnerCls
      }, /* @__PURE__ */ React.createElement(FacebookIcon, null), /* @__PURE__ */ React.createElement("span", null, translations.options.facebook)))), /* @__PURE__ */ React.createElement("li", {
        className: shareListItemCls,
        onClick: this.handleShareClick(SHARE_KEYS.twitter)
      }, /* @__PURE__ */ React.createElement(TwitterShareButton, {
        resetButtonStyle: false,
        url: urlsByPlatform.twitter || url,
        title: translations.messages.twitter,
        className: shareListItemButtonCls
      }, /* @__PURE__ */ React.createElement("div", {
        className: shareListItemButtonInnerCls
      }, /* @__PURE__ */ React.createElement(TwitterIcon, null), /* @__PURE__ */ React.createElement("span", null, translations.options.twitter)))), /* @__PURE__ */ React.createElement("li", {
        className: shareListItemCls,
        onClick: this.handleShareClick(SHARE_KEYS.email)
      }, /* @__PURE__ */ React.createElement(EmailShareButton, {
        resetButtonStyle: false,
        url: urlsByPlatform.email || url,
        subject: translations.emailSubject,
        body: "".concat(translations.messages.email),
        className: shareListItemButtonCls
      }, /* @__PURE__ */ React.createElement("div", {
        className: shareListItemButtonInnerCls
      }, /* @__PURE__ */ React.createElement(MailIcon, null), /* @__PURE__ */ React.createElement("span", null, translations.options.email)))), /* @__PURE__ */ React.createElement("li", {
        className: shareListItemCls,
        onClick: this.handleShareClick(SHARE_KEYS.whatsapp)
      }, /* @__PURE__ */ React.createElement(WhatsappShareButton, {
        resetButtonStyle: false,
        url: urlsByPlatform.whatsapp || url,
        title: translations.messages.whatsapp,
        separator: " - ",
        className: shareListItemButtonCls
      }, /* @__PURE__ */ React.createElement("div", {
        className: shareListItemButtonInnerCls
      }, /* @__PURE__ */ React.createElement(WhatsappIcon, null), /* @__PURE__ */ React.createElement("span", null, translations.options.whatsapp)))), image ? /* @__PURE__ */ React.createElement("li", {
        className: shareListItemCls,
        onClick: this.handleShareClick(SHARE_KEYS.pinterest)
      }, /* @__PURE__ */ React.createElement(PinterestShareButton, {
        resetButtonStyle: false,
        url: urlsByPlatform.pinterest || url,
        description: translations.messages.pinterest,
        media: image,
        className: shareListItemButtonCls
      }, /* @__PURE__ */ React.createElement("div", {
        className: shareListItemButtonInnerCls
      }, /* @__PURE__ */ React.createElement(PinterestLightIcon, null), /* @__PURE__ */ React.createElement("span", null, translations.options.pinterest)))) : null)))), this.el);
    }, "render")
  }]);
}(Component);
_defineProperty(ShareOverlay, "defaultProps", {
  urlsByPlatform: {},
  onShare: null,
  description: null
});
export {
  ShareOverlay
};
